import React from 'react';
import moment from 'moment';
import Button from "@material-ui/core/Button";
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit,openVacSchedule,openStdProduction}) => {
    const rows = [
        { label: 'Modified By', value: data.modifiedBy || '-' },
        { label: 'Modified', value: data.modifiedTime ? moment(data.modifiedTime).format("DD-MM-YYYY HH:mm") : '-' },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <div className='mt-2'>
        <PPMobileCardView
            title={data.name}
            rows={rows}
            menuItems={menuItems}
        >
            <div className="flex-gap-6" style={{ marginTop: 8, padding: '0 10px 10px' }}>
                <Button onClick={openVacSchedule} size="small" color="primary" variant="outlined">Vaccination Schedule</Button>
                <Button onClick={openStdProduction} size="small" color="secondary" variant="outlined">Breed Standard</Button>
            </div>
        </PPMobileCardView>
        </div>
    );
};

export default Mobile;
